<template>
  <v-card>
    <v-card-text>
      <!-- <div>Word of the Day</div> -->
      <p class="text-h5 text--primary">
        {{ election.association.description }}
      </p>
      <p>
        <strong class="overline">
          Time: {{ formatTime(election.start) }} &mdash;
          {{ formatTime(election.end) }}
        </strong>
      </p>

      <div>
        <v-chip small color="green lighten-4" class="mr-1 mb-1">{{ election.voters }} registered</v-chip>
        <v-chip small color="green lighten-4" class="mr-1 mb-1">{{ election.voted }} voted</v-chip>
        <v-chip small color="green lighten-4" class="mr-1 mb-1">{{ election.voters - election.voted }} not voted</v-chip>
      </div>

      <v-divider class="mt-5"></v-divider>
    </v-card-text>
    <v-card-actions class="mt-0 px-4 pb-4">
      <v-btn class="white--text" color="orange darken-2" :to="`/vote/${election.uuid}`">
        Cast Vote
      </v-btn>
      <v-btn text color="primary" @click="reveal = !reveal" v-if="results && election.positions.length > 0">
        Results
      </v-btn>
    </v-card-actions>

    <v-expand-transition>
      <div v-if="reveal && results">
        <v-divider></v-divider>
        <v-card-text>
          <p class="text-h5 text--primary mb-0">Results</p>
          <div class="mb-5">as at {{ formatDate(new Date()) }}</div>

          <section class="d-flex flex-wrap flex-row" style="gap: 16px;">
            <div
              v-for="(position, i) in election.positions"
              :key="position.id"
              style="flex: 1 1 300px; max-width: 400px; min-width: 280px;"
            >
              <v-list disabled dense :color="getColor(i % 4)" class="px-2 rounded-lg elevation-1">
                <h4 class="mb-1">{{ position.description }} POSITION</h4>

                <div>
                  <v-chip outlined x-small class="ml-1">{{ position.votes }} votes</v-chip>
                  <v-chip outlined x-small class="ml-1">
                    {{ election.voted - position.votes }} not voted
                  </v-chip>
                </div>

                <v-list-item-group color="secondary" v-if="position.candidates.length > 0">
                  <v-list-item v-for="candidate in position.candidates" :key="candidate.id" class="px-0">
                    <v-list-item-content>
                      <v-row no-gutters class="flex-row">
                        <v-col cols="3" class="d-flex justify-start">
                          <v-img
                            cover
                            class="candidate-image rounded"
                            :src="candidate.profile.photo ? candidate.profile.photo : '/placeholder.jpg'"
                            width="60"
                            height="90"
                          ></v-img>
                        </v-col>
                        <v-col class="pl-2">
                          <v-list-item-title>
                            <h2 class="mt-1">
                              {{ candidate.votes_count }}
                              <small>{{ candidate.votes_count > 1 ? "votes" : "vote" }}</small>
                            </h2>
                            <v-divider class="my-1"></v-divider>
                          </v-list-item-title>
                          <v-list-item-subtitle class="font-weight-bold">
                            {{ candidate.profile.name }}
                          </v-list-item-subtitle>
                          <small>{{ candidate.profile.reg_number }}</small>
                        </v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>

                <h3 v-else class="my-2 mx-4 red--text text-right">
                  No candidate
                </h3>
              </v-list>
            </div>
          </section>
        </v-card-text>
      </div>
    </v-expand-transition>
  </v-card>
</template>

<script>
import { formatDate } from "../../../tools/format";

export default {
  props: {
    election: {
      type: Object,
      default: () => { },
    },
    results: {
      type: Boolean,
      default: false,
    },
  },

  data: () => ({
    reveal: false,
  }),

  methods: {
    formatDate,
    formatTime(val) {
      return val.substr(0, 5);
    },
    getColor(i) {
      switch (i) {
        case 1:
          return "yellow lighten-5";
        case 2:
          return "teal lighten-5";
        case 3:
          return "blue lighten-5";
        default:
          return "grey lighten-5";
      }
    },
  },
};
</script>

<style>
/* .v-card--reveal {
  bottom: 0;
  opacity: 1 !important;
  position: absolute;
  width: 100%;
} */
</style>
